<div class="small-title">{{'proposalDetails.createOfferTab.yourDataSection.yourData'|translate}}</div>
<br>
<ng-container *ngIf="(user$|async) as user">


  <div class="d-flex flex-column">
    <div class="d-flex">
      <div
        class="info-col small-text">{{'proposalDetails.createOfferTab.yourDataSection.insuranceCompanyName'|translate}}:
      </div>
      <div class="small-text">{{user.company.name}}</div>
    </div>
    <div class="d-flex proposal-details-row">
      <div class="info-col small-text">{{'proposalDetails.createOfferTab.yourDataSection.street'|translate}},
        {{'proposalDetails.createOfferTab.yourDataSection.houseNumber'|translate}}:
      </div>
      <div class="small-text">{{user.company.street}}, {{user.company.houseNumber}}</div>
    </div>
    <div class="d-flex proposal-details-row">
      <div class="info-col small-text">{{'proposalDetails.createOfferTab.yourDataSection.postalCode'|translate}},
        {{'proposalDetails.createOfferTab.yourDataSection.location'|translate}}:
      </div>
      <div class="small-text">{{user.company.postalCode}}, {{user.company.location}}</div>
    </div>
    <div class="d-flex proposal-details-row">
      <div class="info-col small-text">{{'proposalDetails.createOfferTab.yourDataSection.countryCode'|translate}}:</div>
      <div class="small-text">{{user.company.countryCode}}</div>
    </div>
    <div class="d-flex proposal-details-row">
      <div class="info-col small-text">{{'proposalDetails.createOfferTab.yourDataSection.country'|translate}}:</div>
      <div class="small-text">{{'countryCodes.' + user.company.countryCode | translate}}</div>
    </div>
  </div>
  <br>
  <div class="small-title">{{'proposalDetails.createOfferTab.yourDataSection.contactPerson'|translate}}:</div>
  <div class="d-flex flex-column">
    <div class="d-flex proposal-details-row">
      <div class="info-col small-text">{{'proposalDetails.createOfferTab.yourDataSection.firstName'|translate}}:</div>
      <div class="small-text">{{user.firstName}}</div>
    </div>
    <div class="d-flex proposal-details-row">
      <div class="info-col small-text">{{'proposalDetails.createOfferTab.yourDataSection.lastName'|translate}}:</div>
      <div class="small-text">{{user.lastName}}</div>

    </div>
    <div class="d-flex proposal-details-row">
      <div class="info-col small-text">{{'proposalDetails.createOfferTab.yourDataSection.phoneNumber'|translate}}:</div>
      <div class="small-text">{{user.telephoneNumber}}</div>

    </div>
    <div class="d-flex proposal-details-row">
      <div class="info-col small-text">{{'proposalDetails.createOfferTab.yourDataSection.mobileNumber'|translate}}:
      </div>
      <div class="small-text">{{user.mobileNumber}}</div>

    </div>
    <div class="d-flex proposal-details-row">
      <div class="info-col small-text">{{'proposalDetails.createOfferTab.yourDataSection.emailAddress'|translate}}:
      </div>
      <div class="small-text">{{user.email}}</div>
    </div>
  </div>
</ng-container>
